import { render } from "./favourites.vue?vue&type=template&id=6a567da5"
import script from "./favourites.vue?vue&type=script&lang=js"
export * from "./favourites.vue?vue&type=script&lang=js"

import "./favourites.vue?vue&type=style&index=0&id=6a567da5&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__